export default "__VITE_ASSET__CCRpJ7j9__"